module.exports = __webpack_public_path__ + "static/img/RS.a345a50b.svg";